import React from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Chat, Phone } from "@mui/icons-material";
import { UserAuthCard, UserAuthShell } from "../auth/user-auth-layout";

export default function CnLoginView({
  phase,
  clientDisplayName,
  pairingCode,
  setPairingCode,
  phoneNumber,
  setPhoneNumber,
  verifyCode,
  setVerifyCode,
  cooldown,
  busy,
  error,
  info,
  onVerifyPairing,
  onSendCode,
  onPhoneLogin,
  onWechatLogin,
}) {
  const credentials = phase === "credentials";
  return (
    <UserAuthShell maxWidth={440}>
      <UserAuthCard contentSx={{ p: { xs: 3, sm: 4 } }}>
        <Stack spacing={2.5}>
          <Box textAlign="center">
            <Typography
              component="h1"
              sx={{ color: "#253940", fontSize: 26, fontWeight: 700 }}
            >
              登录 mhome.ai
            </Typography>
            <Typography sx={{ mt: 0.75, color: "#71838b" }}>
              中国区 · 手机号或微信登录
            </Typography>
          </Box>
          {clientDisplayName && credentials && (
            <Typography variant="body2" color="text.secondary">
              登录后将安全返回到 {clientDisplayName}
            </Typography>
          )}
          {error && <Alert severity="error">{error}</Alert>}
          {info && <Alert severity="success">{info}</Alert>}
          {phase === "validating" && (
            <Stack alignItems="center" spacing={2} py={3}>
              <CircularProgress size={28} />
              <Typography color="text.secondary">正在验证登录请求…</Typography>
            </Stack>
          )}
          {phase === "pairing" && (
            <>
              <Typography>请输入应用中显示的 6 位配对码</Typography>
              <TextField
                autoFocus
                fullWidth
                label="配对码"
                value={pairingCode}
                inputProps={{ inputMode: "numeric", maxLength: 6 }}
                onChange={(event) =>
                  setPairingCode(event.target.value.replace(/\D/g, ""))
                }
              />
              <Button
                variant="contained"
                disabled={busy}
                onClick={onVerifyPairing}
              >
                {busy ? <CircularProgress size={20} color="inherit" /> : "继续"}
              </Button>
            </>
          )}
          {credentials && (
            <>
              <TextField
                fullWidth
                label="中国大陆手机号"
                value={phoneNumber}
                inputProps={{ inputMode: "tel" }}
                InputProps={{
                  startAdornment: <Phone sx={{ mr: 1 }} color="action" />,
                }}
                onChange={(event) => setPhoneNumber(event.target.value)}
              />
              <Stack direction="row" spacing={1}>
                <TextField
                  fullWidth
                  label="6 位验证码"
                  value={verifyCode}
                  inputProps={{ inputMode: "numeric", maxLength: 6 }}
                  onChange={(event) =>
                    setVerifyCode(event.target.value.replace(/\D/g, ""))
                  }
                />
                <Button
                  variant="outlined"
                  disabled={busy || cooldown > 0}
                  onClick={onSendCode}
                  sx={{ minWidth: 116 }}
                >
                  {cooldown > 0 ? `${cooldown}s` : "获取验证码"}
                </Button>
              </Stack>
              <Button
                variant="contained"
                size="large"
                disabled={busy}
                onClick={onPhoneLogin}
              >
                {busy ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "手机号登录"
                )}
              </Button>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Box sx={{ height: 1, bgcolor: "divider", flex: 1 }} />
                <Typography variant="caption" color="text.secondary">
                  或
                </Typography>
                <Box sx={{ height: 1, bgcolor: "divider", flex: 1 }} />
              </Stack>
              <Button
                variant="outlined"
                size="large"
                disabled={busy}
                startIcon={<Chat />}
                onClick={onWechatLogin}
              >
                微信扫码登录
              </Button>
            </>
          )}
        </Stack>
      </UserAuthCard>
    </UserAuthShell>
  );
}
